<template>
  <div class="card-content">
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>
    </div>
    <div class="card-content-item">
      <span><Skeleton width="100px" height="18px" /></span>
      <div class="card-content-result">
        <strong><Skeleton width="20px" height="30px" /></strong>
      </div>
    </div>
  </div>
</template>
<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'RefundSkeleton',
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mobiles.scss';
@import '@/assets/styles/mobilesFooter.scss';
@import '@/assets/styles/card.scss';

span {
  display: block;
}
strong {
  display: block;
}
.card-content-result {
  margin-top: 8px;
}
</style>
